module.exports = __webpack_public_path__ + "img/image_5.770dcf91.png";